export default function checkNull(value) {
    if (value == null || value === '') {
        return null;
    }
    return value
}
